module.exports = __webpack_public_path__ + "img/HQ-OA-360V03NGU-T.7b08c860.jpg";